import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-stop-icon',
  templateUrl: './stop-icon.component.html',
  styleUrls: ['./stop-icon.component.scss'],
})
export class StopIconComponent {
  @Input() stopType: 'O' | 'D' | 'S';
  @Input() stopNumber: string;
  @Input() routeColor: string;

  // TODO switch stopType to enum or more explicit type
}
